import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import PeopleIcon from "@material-ui/icons/People";
import SettingsIcon from "@material-ui/icons/Settings";
import DnsIcon from "@material-ui/icons/Dns";
import ViewCarouselIcon from "@material-ui/icons/ViewCarousel";
import EventNoteIcon from "@material-ui/icons/EventNote";
import { Link } from "react-router-dom";
import BrandingWatermarkIcon from "@material-ui/icons/BrandingWatermark";
import CategoryIcon from "@material-ui/icons/Category";
import TocIcon from "@material-ui/icons/Toc";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import MapIcon from "@material-ui/icons/Map";
import PaymentIcon from "@material-ui/icons/Payment";
import DriveEtaIcon from "@material-ui/icons/DriveEta";
import CommuteIcon from "@material-ui/icons/Commute";
import FlareIcon from "@material-ui/icons/Flare";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import TextFieldsIcon from "@material-ui/icons/TextFields";
import TextsmsIcon from "@material-ui/icons/Textsms";
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";
import CardGiftcardIcon from "@material-ui/icons/CardGiftcard";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import BusinessIcon from "@material-ui/icons/Business";
import FormatListNumberedRtlIcon from "@material-ui/icons/FormatListNumberedRtl";

export const mainListItems = (
  <div>
    <Link to="/main/users">
      <ListItem button>
        <ListItemIcon>
          <PeopleIcon />
        </ListItemIcon>
        <ListItemText primary="کاربران" />
      </ListItem>
    </Link>
    <Link to="/main/agents">
      <ListItem button>
        <ListItemIcon>
          <SupervisedUserCircleIcon />
        </ListItemIcon>
        <ListItemText primary="نمایندگان فروش" />
      </ListItem>
    </Link>
    <Link to="/main/Purchases">
      <ListItem button>
        <ListItemIcon>
          <ShoppingCartIcon />
        </ListItemIcon>
        <ListItemText primary="فروش" />
      </ListItem>
    </Link>
    <Link to="/main/suggestions">
      <ListItem button>
        <ListItemIcon>
          <EventNoteIcon />
        </ListItemIcon>
        <ListItemText primary="انتقادات و پیشنهادات" />
      </ListItem>
    </Link>
    <Link to="/main/products">
      <ListItem button>
        <ListItemIcon>
          <DnsIcon />
        </ListItemIcon>
        <ListItemText primary="محصولات" />
      </ListItem>
    </Link>
    <Link to="/main/brands">
      <ListItem button>
        <ListItemIcon>
          <BrandingWatermarkIcon />
        </ListItemIcon>
        <ListItemText primary="برند" />
      </ListItem>
    </Link>
    <Link to="/main/subCategories">
      <ListItem button>
        <ListItemIcon>
          <BrandingWatermarkIcon />
        </ListItemIcon>
        <ListItemText primary="زیر برند" />
      </ListItem>
    </Link>
    <Link to="/main/adss">
      <ListItem button>
        <ListItemIcon>
          <TocIcon />
        </ListItemIcon>
        <ListItemText primary="تبلیغات" />
      </ListItem>
    </Link>
    <Link to="/main/adscategories">
      <ListItem button>
        <ListItemIcon>
          <TocIcon />
        </ListItemIcon>
        <ListItemText primary=" دسته بندی تبلیغات " />
      </ListItem>
    </Link>
    <Link to="/main/categories">
      <ListItem button>
        <ListItemIcon>
          <CategoryIcon />
        </ListItemIcon>
        <ListItemText primary="دسته بندی" />
      </ListItem>
    </Link>
    <Link to="/main/provinces">
      <ListItem button>
        <ListItemIcon>
          <MapIcon />
        </ListItemIcon>
        <ListItemText primary="استان" />
      </ListItem>
    </Link>
    <Link to="/main/cities">
      <ListItem button>
        <ListItemIcon>
          <LocationCityIcon />
        </ListItemIcon>
        <ListItemText primary="شهر" />
      </ListItem>
    </Link>
    <Link to="/main/paymentTypes">
      <ListItem button>
        <ListItemIcon>
          <PaymentIcon />
        </ListItemIcon>
        <ListItemText primary="نحوه پرداخت" />
      </ListItem>
    </Link>
    <Link to="/main/vehiclebrands">
      <ListItem button>
        <ListItemIcon>
          <BrandingWatermarkIcon />
        </ListItemIcon>
        <ListItemText primary="برند ماشین" />
      </ListItem>
    </Link>
    <Link to="/main/vehicleclasses">
      <ListItem button>
        <ListItemIcon>
          <CommuteIcon />
        </ListItemIcon>
        <ListItemText primary="کلاس ماشین" />
      </ListItem>
    </Link>
    <Link to="/main/vehicles">
      <ListItem button>
        <ListItemIcon>
          <DriveEtaIcon />
        </ListItemIcon>
        <ListItemText primary="ماشین" />
      </ListItem>
    </Link>
    <Link to="/main/festivals">
      <ListItem button>
        <ListItemIcon>
          <FlareIcon />
        </ListItemIcon>
        <ListItemText primary="جشنواره" />
      </ListItem>
    </Link>
    <Link to="/main/books">
      <ListItem button>
        <ListItemIcon>
          <MenuBookIcon />
        </ListItemIcon>
        <ListItemText primary="دفترچه خودرو" />
      </ListItem>
    </Link>
    <Link to="/main/machinecomp">
      <ListItem button>
        <ListItemIcon>
          <MonetizationOnIcon />
        </ListItemIcon>
        <ListItemText primary="اشانتیون های دفترچه" />
      </ListItem>
    </Link>
    <Link to="/main/comp">
      <ListItem button>
        <ListItemIcon>
          <CardGiftcardIcon />
        </ListItemIcon>
        <ListItemText primary="اشانتیون" />
      </ListItem>
    </Link>
    <Link to="/main/settings">
      <ListItem button>
        <ListItemIcon>
          <SettingsIcon />
        </ListItemIcon>
        <ListItemText primary="تنظیمات" />
      </ListItem>
    </Link>
    {/* <Link to='/main/string'>
      <ListItem button>
        <ListItemIcon>
          <TextFieldsIcon />
        </ListItemIcon>
        <ListItemText primary='متن ها' />
      </ListItem>
    </Link> */}
    <Link to="/main/reminder">
      <ListItem button>
        <ListItemIcon>
          <TextsmsIcon />
        </ListItemIcon>
        <ListItemText primary="پیامک یادآوری" />
      </ListItem>
    </Link>
    <Link to="/main/cityBrands">
      <ListItem button>
        <ListItemIcon>
          <ViewCarouselIcon />
        </ListItemIcon>
        <ListItemText primary="برندهای شهر" />
      </ListItem>
    </Link>
    <Link to="/main/bussinessreport">
      <ListItem button>
        <ListItemIcon>
          <FormatListNumberedRtlIcon />
        </ListItemIcon>
        <ListItemText primary="گزارش مشاغل " />
      </ListItem>
    </Link>
    <Link to="/main/bussinesscategory">
      <ListItem button>
        <ListItemIcon>
          <BusinessIcon />
        </ListItemIcon>
        <ListItemText primary="دسته بندی مشاغل " />
      </ListItem>
    </Link>
    <Link to="/main/business">
      <ListItem button>
        <ListItemIcon>
          <BusinessCenterIcon />
        </ListItemIcon>
        <ListItemText primary="مشاغل" />
      </ListItem>
    </Link>
  </div>
);
